<template>
  <component :is="type + 'Copy'" v-if="type" ref="copyEnergeticModal" />
</template>
<script>
import PowerCopy from './power/Copy'
import GasCopy from './gas/Copy'
import WaterCopy from './water/Copy'
import HeatCopy from './heat/Copy'
import { mapState } from 'vuex'

export default {
  components: {
    PowerCopy,
    GasCopy,
    WaterCopy,
    HeatCopy,
  },
  data() {
    return {
      type: null,
      to: null,
    }
  },
  computed: {
    ...mapState({
      energetic: (state) => state.energetic.current.data,
    }),
  },
  methods: {
    copyEnergetic(e) {
      e.preventDefault()
      this.$refs.copyEnergeticModal.$validator.validateAll().then(() => {
        if (
          !this.$refs.copyEnergeticModal.errors.any() &&
          !this.$refs.copyEnergeticModal.loading
        ) {
          this.$refs.copyEnergeticModal.saving = true
          this.$api
            .post('energetics/copy', {
              from: {
                customer_id: this.energetic.customer_id,
                id: this.energetic.id,
              },
              to: this.to,
              data: this.$refs.copyEnergeticModal.form,
            })
            .then((res) => {
              this.$swal({
                type: 'success',
                position: 'top',
                showCloseButton: true,
                text: res.data.message,
                timer: 5000,
              })

              this.$root.$emit('modal-hide', 'copy-energetic')
              this.$router.push({
                name: 'customerEnergeticsDetail',
                params: {
                  id: res.data.meta.customer_id,
                  energetics_id: res.data.meta.id,
                },
              })
            })
            .catch((err) => {
              this.$swal({
                type: 'error',
                position: 'top',
                showCloseButton: true,
                text:
                  err.response.data.message ||
                  'Vyskytla sa chyba pri presúvaní odberného miesta',
                timer: 5000,
              })
            })
            .finally(() => {
              this.$refs.copyEnergeticModal.saving = false
            })
        } else {
          this.$swal({
            type: 'warning',
            position: 'top',
            showCloseButton: true,
            text: 'Formulár nieje správne vyplnený',
            timer: 5000,
          })
        }
      })
    },
    reset() {
      Object.assign(
        this.$refs.copyEnergeticModal.$data,
        this.$refs.copyEnergeticModal.$options.data(),
      )
      Object.assign(this.$data, this.$options.data())
    },
  },
}
</script>
